module.exports = __webpack_public_path__ + "img/h5img11.2ffb859f.png";